import CompraAPI from "./../../api/compra";
import store from "./../store";

function getDefaultState() {
    return {
        saidas: {
            labels:[],
            datasets: []
        },
        compras: {
            labels:[],
            datasets: []
        }
    };
  }
  
  const state = getDefaultState();
  
  const getters = {};
  
  const mutations = {
    setLabelsSaidas(state, labels) {
        state.saidas.labels = labels;
    },
    addDatasetSaida(state, dataset) {
        state.saidas.datasets.push(dataset);
    },
    setLabelsCompras(state, labels) {
        state.compras.labels = labels;
    },
    addDatasetCompra(state, dataset) {
        state.compras.datasets.push(dataset);
    }
  };
  
  const actions = {
    buscarDadosGrafico: ({commit}, fornecedor) => {
        store.dispatch("loading/habilitarLoading",true);

        const token = localStorage.getItem('token');
        
        const headers = {
            "Authorization": `Bearer ${token}`
        };
  
        const params = {
          fornecedor: fornecedor.id
        }
  
        CompraAPI.getDadosGraficoFornecedor(headers, params)
          .then(response => {
            const token = response.data.token;
            localStorage.setItem('token', token);
            
            commit('setLabelsSaidas', response.data.movimentacoes.ref || []);
            commit('setLabelsCompras', response.data.movimentacoes.ref || []);
  
            const saidas = {
              label: 'Saídas',
              backgroundColor: '#D60E2B',
              data: response.data.movimentacoes.saidas || []
            };
            commit('addDatasetSaida', saidas);

            const compras = {
                label: 'Compras',
                backgroundColor: '#043554',
                data: response.data.movimentacoes.compras || []
            };
            commit('addDatasetCompra', compras);

            store.dispatch("loading/habilitarLoading",false);
          })
          .catch(() => {
            store.dispatch("loading/habilitarLoading",false);
            this.Helpers.logout();
          })
    }
  };
  
  export default { namespaced: true, state, mutations, getters, actions };
    